import { ChangeDetectorRef, Component, OnInit, NgZone } from '@angular/core';

import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service'
import { SpinnerService } from './services/spinner.service';
import { NotificationService } from './services/notifications.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {

  HTTPActivity: boolean = false;
  pageOwnsLoader: boolean = false;
  private applicationsRequestInFlight: boolean = false;

  constructor(private authService: AuthService,
    public userService: UserService,
    private readonly notificationService: NotificationService,
    private readonly spinner: SpinnerService,
    private readonly ngZone: NgZone,
    private readonly cdr: ChangeDetectorRef) {
    if (window.location.pathname.includes('/preference')) {
      this.spinner.setPageOwnsLoader(true);
    }
    this.spinner.getHttpStatus().subscribe((status: boolean) => {
      this.ngZone.run(() => {
        this.HTTPActivity = status;
        this.cdr.detectChanges();
      });
    });
    this.spinner.getPageOwnsLoader().subscribe((owns: boolean) => {
      this.ngZone.run(() => {
        this.pageOwnsLoader = owns;
        this.cdr.detectChanges();
      });
    });
    this.userService.user$.subscribe((user) => {
      if (user && this.notificationService.applicationDetails.length === 0 && !this.applicationsRequestInFlight) {
        this.applicationsRequestInFlight = true;
        this.notificationService.getApplications(user.authId).subscribe({
          next: (apps: any) => {
            this.notificationService.setApplications(apps);
            this.applicationsRequestInFlight = false;
          },
          error: () => {
            this.applicationsRequestInFlight = false;
          },
        });
      }
    });
  }

  ngOnInit() {
    this.authService.localAuthSetup();
    this.authService.handleAuthCallback();
  }
}
